exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rotate[data-v-5afbee74] {\n  color: #3498db;\n  -webkit-animation: spin-data-v-5afbee74 1s linear infinite;\n          animation: spin-data-v-5afbee74 1s linear infinite;\n}\n@-webkit-keyframes spin-data-v-5afbee74 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spin-data-v-5afbee74 {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n", ""]);

// exports
